import { Temperature, Weight } from 'careit';
import { useTranslation } from 'react-i18next';
import { useMeasureFieldUnits } from 'src/components/MeasureField';
import { useFoodTypes } from 'src/constants';

export const useWeightsAndTempsColumns = ({
  hide = false,
  filterable = false,
} = {}) => {
  const { t } = useTranslation('translation');
  const foodTypes = useFoodTypes();
  const { defaultWeightUnit, defaultTemperatureUnit } = useMeasureFieldUnits();

  const updatedFoodTypes = [
    {
      title: t('data.food-types.total-food'),
      key: 'total_food',
    },
    ...foodTypes,
  ];

  const foodTypesTemp = [
    {
      title: t('data.food-types.dairy-pickup-temp'),
      key: 'dairy_pickup_temp',
    },
    {
      title: t('data.food-types.dairy-dropoff-temp'),
      key: 'dairy_dropoff_temp',
    },
    {
      title: t('data.food-types.produce-pickup-temp'),
      key: 'produce_pickup_temp',
    },
    {
      title: t('data.food-types.produce-dropoff-temp'),
      key: 'produce_dropoff_temp',
    },
    {
      title: t('data.food-types.meat-pickup-temp'),
      key: 'meat_pickup_temp',
    },
    {
      title: t('data.food-types.meat-dropoff-temp'),
      key: 'meat_dropoff_temp',
    },
    {
      title: t('data.food-types.prepared-pickup-temp'),
      key: 'prepared_pickup_temp',
    },
    {
      title: t('data.food-types.prepared-dropoff-temp'),
      key: 'prepared_dropoff_temp',
    },
  ];

  return [
    ...updatedFoodTypes.map((food) => ({
      field: food.key + '_weight',
      type: 'number',
      headerName: `${food.title} (${defaultWeightUnit.label})`,
      width: 150,
      hide,
      valueGetter: (value, _row) =>
        new Weight(value ?? 0, 'lbs')
          .into(defaultWeightUnit?.value ?? 'lbs')
          .valueOf(),
      valueFormatter: (value) => Math.round(value * 100) / 100,
      csvValueGetter: (value) =>
        new Weight(value ?? 0, 'lbs').into(defaultWeightUnit?.value ?? 'lbs')
          .value,
      filterable,
    })),
    ...foodTypesTemp.map((food) => ({
      field: food.key,
      type: 'number',
      headerName: `${food.title} (${defaultTemperatureUnit.label})`,
      width: 150,
      hide,
      valueGetter: (value, _row) =>
        Number.isFinite(value)
          ? new Temperature(value, 'f')
              .into(defaultTemperatureUnit?.value ?? 'f')
              .valueOf()
          : null,
      valueFormatter: (value) =>
        value !== null ? Math.round(value * 10) / 10 : '-',
      filterable,
    })),
  ];
};

export const useGetWeightValues = () => {
  const { defaultWeightUnit } = useMeasureFieldUnits();
  return (_value, row) =>
    new Weight(
      new Weight(_value ?? 0, 'lbs').as(
        row[row.field + '_unit'] ?? defaultWeightUnit?.value ?? 'lbs'
      ),
      row[row.field + '_unit'] ?? defaultWeightUnit?.value ?? 'lbs'
    );
};
